import React from "react";
import JamiaHeader from "components/headers/JamiaHeader";
import FiveColumnDark from "../footers/FiveColumnDark";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import GlobalStyles from "../../styles/GlobalStyles";
import ScrollToTop from "components/misc/ScrollToTop";

const Layout = ({ children }) => {
  return (
    <AnimationRevealPage>
      <GlobalStyles />

      {/* Header */}
      <JamiaHeader />

      {/* Main content with responsive wrapper */}
      <div
        style={{
          padding: "0 16px",
          maxWidth: 1400,
          margin: "0 auto",
          width: "100%",
          minHeight: "60vh",
        }}
      >
        {children}
      </div>

      {/* Footer */}
      <FiveColumnDark />

      {/* Scroll to Top Button */}
      <ScrollToTop />
    </AnimationRevealPage>
  );
};

export default Layout;
